export default "__VITE_ASSET__20e04001__"